<template>
  <div class="has-text-centered">
    <p>
      Em até <strong>2 horas</strong> o valor solicitado<br />estará disponível
      na sua conta
    </p>

    <base-summary>
      <template #header>
        <strong class="is-size-6 is-size-5-tablet">
          Resumo da solicitação
        </strong>
      </template>
      <div class="c-base-summary__wrapper">
        <div class="columns is-mobile is-multiline has-text-left">
          <div class="column is-half">Valor solicitado:</div>
          <div class="column is-half has-text-right">
            <strong>{{ transaction.amount | currency }}</strong>
          </div>
          <div class="column is-half">Custo da transação:</div>
          <div class="column is-half has-text-right">
            <div class="c-base-summary__content-bordered">
              <strong class="has-text-grey">R$ 0,00</strong>
            </div>
          </div>
          <div class="column is-half">Total:</div>
          <div class="column is-half has-text-right">
            <strong class="has-text-support">{{
              transaction.amount | currency
            }}</strong>
          </div>
          <div class="column is-full">
            <p class="has-text-centered margin-bottom">
              <small>Conta a ser depositado:</small>
            </p>
            <div class="c-base-summary__account-user-pix">
              <p class="c-base-summary__account-user-pix--logo">PIX</p>
              <p class="c-base-summary__account-user-pix--info">
                <strong>{{
                  transaction.details.bank_account.owner_full_name
                }}</strong>
                <br />
                <span v-if="transaction.details.bank_account?.bank?.name">
                  {{ transaction.details.bank_account.owner_cpf }} ·
                  {{ transaction.details.bank_account.bank.name }}
                </span>
                <span v-else>
                  {{ transaction.details.bank_account.owner_cpf }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <p>
          ID da transação<br />
          <strong>
            {{ transaction.transaction_id }}
          </strong>
        </p>
      </template>
    </base-summary>
    <router-link
      :to="{ name: 'carteira-saque' }"
      class="button is-black is-outlined is-big margin-bottom"
    >
      Fazer nova transferência
    </router-link>
  </div>
</template>

<script>
import BaseSummary from '@/components/Wallet/BaseSummary.vue'

export default {
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },

  components: {
    BaseSummary,
  },
}
</script>

<style lang="scss">
.c-base-summary {
  &__account-user-pix {
    &--logo {
      margin-bottom: 5px;
      font-size: 12px;
      font-weight: bold;
      line-height: 1.33;
      color: #048a8b;
    }

    &--info {
      font-size: 16px;
      font-weight: bold;
      line-height: 1;
      color: $gray-5;

      span {
        line-height: 1.29;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
}
</style>
